import { fireBIEvent } from 'public/bi-events.js'; 
import wixLocation from 'wix-location';

$w.onReady(function () {

    ////////////////////////////////////////////////////////

    $w('#DiscoverMore1').onClick(() => {
        const biFields = {
            button_name: "discover_more_header",
            topic: "Discover More",
            url: wixLocation.url
        }
        fireBIEvent(19, 703, biFields);
    });

    $w('#GetStarted1').onClick(() => {
        const biFields = {
            button_name: "get_started_header",
            topic: "Get Started",
            url: wixLocation.url
        }
        fireBIEvent(19, 703, biFields);
    });

    ////////////////////////////////////////////////////////

    $w('#DiscoverMore2').onClick(() => {
        const biFields = {
            button_name: "discover_more_retail_fold",
            topic: "Discover More",
            url: wixLocation.url
        }
        fireBIEvent(19, 703, biFields);
    });

    ////////////////////////////////////////////////////////
    
    $w('#DiscoverMore3').onClick(() => {
        const biFields = {
            button_name: "discover_more_bookings_fold",
            topic: "Discover More",
            url: wixLocation.url
        }
        fireBIEvent(19, 703, biFields);
    });

    ////////////////////////////////////////////////////////

    $w('#DiscoverMore4').onClick(() => {
        const biFields = {
            button_name: "discover_more_events_fold",
            topic: "Discover More",
            url: wixLocation.url
        }
        fireBIEvent(19, 703, biFields);
    });

    ////////////////////////////////////////////////////////

    $w('#GetStarted2').onClick(() => {
        const biFields = {
            button_name: "get_started_how_it_works_fold",
            topic: "Get Started",
            url: wixLocation.url
        }
        fireBIEvent(19, 703, biFields);
    });

    ////////////////////////////////////////////////////////

    $w('#GetStarted3').onClick(() => {
        const biFields = {
            button_name: "get_started_one_provider_fold",
            topic: "Get Started",
            url: wixLocation.url
        }
        fireBIEvent(19, 703, biFields);
    });

    ////////////////////////////////////////////////////////

    $w('#ShopPOS1').onClick(() => {
        const biFields = {
            button_name: "shop_pos_pos_for_every_business_fold",
            topic: "Shop POS",
            url: wixLocation.url
        }
        fireBIEvent(19, 703, biFields);
    });

    ////////////////////////////////////////////////////////

    $w('#ShopPOS2').onClick(() => {
        const biFields = {
            button_name: "shop_pos_let_customers_pick_fold",
            topic: "Shop POS",
            url: wixLocation.url
        }
        fireBIEvent(19, 703, biFields);
    });

    ////////////////////////////////////////////////////////
    
    $w('#GetStartedCloser').onClick(() => {
        const biFields = {
            button_name: "get_started_bottom_fold",
            topic: "Get Started",
            url: wixLocation.url
        }
        fireBIEvent(19, 703, biFields);
    });

    ////////////////////////////////////////////////////////
});